"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthRoutes = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Login_1 = require("./Login");
const Logout_1 = require("./Logout");
const SocialRedirect_1 = require("./SocialRedirect");
const RenewModal_1 = require("./RenewModal");
const react_router_dom_2 = require("react-router-dom");
const tokens_1 = require("../logic/tokens");
const AuthRoutes = ({ children, config, authManager, t, container, onRedirect, onRenewClose }) => {
    const location = (0, react_router_dom_2.useLocation)();
    const tokens = (0, tokens_1.pickTokensFromSearch)(location.search);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RenewModal_1.RenewModal, { authManager: authManager, isModal: true, config: config, t: t, tokens: tokens, onClose: onRenewClose }),
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/oauth2callback", component: () => react_1.default.createElement(SocialRedirect_1.SocialRedirect, { t: t, authManager: authManager, onSuccess: () => { }, onError: () => { } }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: `/login`, exact: true, component: () => (react_1.default.createElement(Login_1.Login, { config: config, authManager: authManager, t: t, container: container, onRedirect: onRedirect, tokens: tokens })) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/logout', exact: true, component: Logout_1.Logout }),
            children)));
};
exports.AuthRoutes = AuthRoutes;
//# sourceMappingURL=AuthRoutes.js.map